<mat-toolbar>
  @if (isHandset$ | async) {
    @if (showMenuButton) {
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="toggleDrawer.emit()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    }
    <span><mat-icon fontIcon="luggage"></mat-icon> Tourist</span>
  }
  
    <app-breadcrumb></app-breadcrumb>
    <span class="spacer"></span>
    <!-- On mobile the Profile bottom tab replaces this, so hide it to avoid
         a duplicate person icon. Desktop keeps it (no bottom nav there). -->
    @if ((isHandset$ | async) === false) {
      <app-profile-menu></app-profile-menu>
    }
  </mat-toolbar>
